import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

import { FileInput, FileField, PageFooter, SaveButton, Button, required } from "jazasoft";
import SimpleForm from "jazasoft/lib/mui/form/SimpleForm";

const FormFooter = props => (
  <PageFooter>
    <SaveButton label="Submit" {...props} />
    <Button onClick={props.onClose} color="default" variant="contained">
      Close
    </Button>
  </PageFooter>
);

const MarkerUploadDialog = ({ open, onSubmit, onClose }) => {
  return (
    <Dialog id="import-dialog" fullWidth={true} maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle id="import-dialog-title">Upload Markers</DialogTitle>

      <SimpleForm style={{ margin: "1.5em" }} onSubmit={onSubmit} footer={<FormFooter onClose={onClose} />}>
        <FileInput
          source="file"
          label="Related files"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          xs={12}
          fullWidth
          validate={required()}>
          <FileField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Dialog>
  );
};

export default MarkerUploadDialog;
